<template>
  <b-modal id="customer-show-history-entry" class="customer-show-history-entry" ref="modal" :title="dialog_title"
    @hidden="onClose" hide-footer>
    <customer-show-document @add="onDocumentAdded" @edit="onDocumentEdited" ref="showdocument" :customer="customer"
      :embed="true"></customer-show-document>

    <div class="row form-group">
      <div class="col">
        <div class="customer-info">
          <div class="customer-photo" :style="{ 'background-image': 'url(' + customer.photo + ')' }"></div>
          <div class="customer-data">
            {{ customer.full_name }}
            <br />
            {{ customer.phone || customer.phone_alt }} | {{ customer.nif }}
          </div>
        </div>
      </div>
    </div>

    <div class="row form-group">
      <div class="col-sm-5">
        <input type="datetime-local" id="entry_show_date" class="form-control" v-model="date" :readonly="readonly" />
        <label for="entry_show_date" class="wabident-info">Fecha</label>
      </div>
      <div class="col-sm-7">
        <select id="entry_select_doctor" v-model="doctor_id" class="custom-select" :disabled="!can_edit_doctor">
          <option :value="null">Selecciona un Doctor</option>
          <option v-for="(doctor, i) in doctors" :key="i" :value="doctor.doctor.id" :disabled="doctor.is_active == 0">
            {{ doctor.name }} <span v-if="doctor.is_active == 0">- Inactiv@</span>
          </option>
        </select>
        <label for="entry_select_doctor" class="wabident-info">Doctor</label>
      </div>
    </div>

    <!-- Customer Treatment Selector -->
    <div v-if="!readonly" class="form-group row" :class="{ mb4px: selected_treatment_ids }">
      <div class="col-sm-12">
        <select v-model="selected_treatment" class="custom-select wabident-small" :readonly="readonly">
          <option value="0">Selecciona tratamiento</option>
          <option v-for="treatment in filtered_customer_treatments" :key="treatment.id" :value="treatment.id">
            {{ getTreatmentName(treatment, true) }}
          </option>
        </select>
      </div>
    </div>

    <!-- Treatment List -->
    <div v-show="selected_treatment_ids.length" class="form-group row no-gutters">
      <div class="col-sm-12">
        <a @click="removeTreatment(treatment.id)" role="button" class="
                            btn
                            wabident-badge wabident-badge__clear wabident-badge__ellipsis
                          " v-for="treatment in selected_customer_treatments" style="margin: 4px"
          :key="treatment.id">{{
            getTreatmentName(treatment)
          }}</a>
      </div>
    </div>

    <div v-if="selected_treatment_ids.length && !is_editing" class="form-group row no-gutters">
      <div class="col-md-6">
        <div class="form-check form-check-inline mb-2">
          <input v-model="is_done" class="form-check-input" type="checkbox" id="entry_is_done" value="true" />
          <label class="form-check-label" for="entry_is_done">Marcar tratamientos como realizados
          </label>
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-check form-check-inline mb-2">
          <input v-model="assign_doctor" class="form-check-input" type="checkbox" id="entry_assign_doctor"
            value="true" />
          <label class="form-check-label" for="entry_assign_doctor">Asignar a Doctor/a &nbsp; <i class="fa fa-comment"
              data-toggle="tooltip" title="Solo para tratamientos sin doctor asignado"></i>
          </label>
        </div>
      </div>
    </div>

    <div class="row form-group mt-3">
      <div class="col-md-12">
        <input type="text" id="title" class="form-control" v-model="title" placeholder="Escribe el título ...">
      </div>
      <div class="col-md-12">
        <label for="entry_select_notes" class="wabident-info">
          Información historia clínica
        </label>
        <quill-editor id="entry_select_notes" :options="options" v-model="notes"></quill-editor>
      </div>
    </div>

    <div class="row form-group" v-if="show_public_note">
      <div class="form-check form-check-inline mb-2">
        <input v-model="is_public" class="form-check-input" type="checkbox" id="app_new_public" value="true" />
        <label class="form-check-label" for="app_new_public"><strong>NOTA PÚBLICA:</strong> Aparece en el historial que
          se
          imprimirá a paciente</label>
      </div>
    </div>

    <div v-if="is_core">
      <customer-document-list :customer="customer" :documents="documents" @add="addDocument" @edit="editDocument">
      </customer-document-list>
    </div>

    <div v-if="!readonly" class="row form-group">
      <div class="col buttons-column text-center">
        <button :disabled="is_loading" @click="deleteEntry" v-show="is_editing"
          class="btn btn-wabident-delete float-left" style="width: 53.6px; height: 53.6px"></button>
        <button @click="submitEntry" :disabled="is_loading" type="button" class="btn btn-primary btn-wabident">
          <span v-if="is_editing">Modificar Historia</span>
          <span v-else>Crear Historia</span>
        </button>
      </div>
    </div>


  </b-modal>
</template>

<script>
export default {
  props: {
    customer: { required: true },
    readonly: { default: false },
  },
  data() {
    return {
      is_done: false,
      assign_doctor: false,
      is_editing: false,
      is_loading: false,
      is_public: false,
      date: '',
      doctor_id: null,
      selected_treatment_ids: [],
      customer_treatments: [],
      selected_treatment: 0,
      history_id: 0,
      history_entry: null,
      documents: [],
      notes: "",
      title: "",
      options: {
        placeholder: "Introduce texto ...",
        modules: {
          toolbar: [
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            ["bold", "italic", "underline", "strike"],
            [{ align: [] }, { list: "ordered" }, { list: "bullet" }],
            [{ indent: "-1" }, { indent: "+1" }],
            ["blockquote", "code-block", "link"],
            ["clean"],
          ],
        },
      },
    };
  },
  watch: {
    selected_treatment(value) {
      if (value) {
        if (this.selected_treatment_ids.indexOf(value) < 0) {
          this.selected_treatment_ids.push(value);
        }
        this.selected_treatment = 0;
      }
    },
  },
  computed: {
    can_edit_doctor() {
      return !this.readonly || !this.default_doctor_id;
    },
    document_ids() {
      if (!this.documents) {
        return [];
      }

      return this.documents.map((d) => {
        return d.id;
      });
    },
    show_public_note() {
      if (!this.customer) return false;
      return !this.is_core && this.clinic_type != 'dental';
    },
    api_enabled() {
      if (!this.clinic) return false;
      return this.clinic.config.enable_api || false;
    },
    clinic_type() {
      if (!this.clinic) return null;
      return this.clinic.type;
    },
    default_doctor_id() {
      if (!this.clinic) return null;
      if (this.clinic.role == "doctor") return this.clinic.doctor_id;
      return null;
    },
    dialog_title() {
      if (this.readonly) return "Ver Entrada";
      return this.is_editing ? "Editar Entrada" : "Añadir Entrada";
    },
    doctors() {
      if (!this.clinic) return [];
      if (this.is_editing) return this.clinic.doctors
      return this.clinic.doctors.filter((x) => {
        return x.is_active != 0;
      });
    },
    filtered_customer_treatments() {
      return Object.values(this.customer_treatments).filter((t) => {
        if (!this.doctor_id || !t.doctor_id) return true;
        return this.doctor_id == t.doctor_id;
      });
    },
    selected_customer_treatments() {
      if (!this.customer_treatments) return [];
      return Object.values(this.customer_treatments).filter((treatment) => {
        return this.selected_treatment_ids.indexOf(treatment.id) >= 0;
      });
    },
    ...mapGetters(["msgwindow", "errorwindow", "clinic", "is_core"]),
  },
  methods: {
    onDocumentAdded(document) {
      this.documents.push(document);
    },
    onDocumentEdited(document) {
      this.documents = this.documents.filter((d) => {
        return d.id != document.id;
      });
      this.documents.push(document);
    },
    addDocument() {
      let history_entry_id = this.history_entry ? this.history_entry.id : null;
      this.$refs.showdocument.showNew(this.customer, null, history_entry_id, this.doctor_id);
    },
    editDocument(document) {
      this.$refs.showdocument.showEdit(this.customer, document);
    },
    onClose() { },
    showNew(treatment = null) {
      this.documents = [];
      this.history_entry = null;
      this.is_editing = false;
      this.is_loading = false;
      this.date = moment().format('YYYY-MM-DDTHH:mm');
      this.doctor_id = (treatment && treatment.doctor_id) ? treatment.doctor_id : this.default_doctor_id;
      this.notes = "";
      this.title = "";
      this.history_id = 0;
      this.is_public = false;
      this.selected_treatment_ids = treatment ? [treatment.id] : [];
      this.selected_treatment = 0;
      this.getCustomerTreatments();
      this.is_done = false;
      this.assign_doctor = false;
      this.$refs.modal.show();
    },
    showEdit(entry) {
      this.history_entry = entry;
      this.documents = this.history_entry.documents;
      this.is_editing = true;
      this.is_loading = false;
      this.date = moment(entry.created_at).format('YYYY-MM-DDTHH:mm');
      this.doctor_id = entry.doctor_id;
      this.notes = entry.notes;
      this.title = entry.title;
      this.history_id = entry.id;
      this.is_public = entry.is_public;
      this.selected_treatment = 0;
      this.is_done = false;
      this.assign_doctor = false;
      this.getCustomerTreatments(entry);
      this.$refs.modal.show();
    },
    deleteEntry() {
      this.errorwindow.show(
        "Confirmación",
        "¿Desea borrar esta historia?",
        "Borrar",
        "Cancelar",
        this.onDeleteConfirm,
        null
      );
    },
    onDeleteConfirm() {
      if (this.is_editing && !this.is_loading) {
        this.is_loading = true;
        axios
          .post(
            `/customer/${this.customer.id}/history_entry/${this.history_id}`,
            { _method: "delete" }
          )
          .then((response) => {
            if (response.data.error) {
              this.errorwindow.show("Error", response.data.error);
            } else {
              this.msgwindow.success("Historia borrada con éxito");
            }

            this.$emit("submit");
            this.$refs.modal.hide();
            this.is_loading = false;
          })
          .catch((error) => {
            console.log("[ERR] deleteHistoryEntry:", error.response.data);
            this.is_loading = false;
          });
      }
    },
    submitEntry() {
      if (!this.doctor_id) {
        this.errorwindow.show('Error', 'Por favor, selecciona Doctor/a para asignar a la Historia Clínica')
        return;
      }
      if (this.is_editing) {
        this.modifyEntry();
      } else {
        this.createEntry();
      }
    },
    getTreatmentName(treatment, full = false) {
      let ret = treatment.product ? treatment.full_name : treatment.notes;

      if (this.clinic_type == "dental") {
        if (treatment.teeth && treatment.teeth.length > 0) {
          ret += "(" + treatment.teeth.join(",") + ")";
        }
      }

      if (full) {
        ret += " - " + moment(treatment.created_at).format('DD/MM/YY');
        if (treatment.is_done) {
          ret += " - Realizado";
        }
      }

      return ret;
    },
    modifyEntry() {
      if (!this.is_loading) {
        this.is_loading = true;
        axios
          .post(
            `/customer/${this.customer.id}/history_entry/${this.history_id}`,
            this.getParameters()
          )
          .then((response) => {
            if (response.data.error) {
              this.errorwindow.show("Error", response.data.error);
            } else {
              this.msgwindow.success("Historia modificada con éxito");
            }

            this.$emit("submit");
            this.$refs.modal.hide();
          })
          .catch((error) => {
            console.log("[ERR] editEntry", error);
          })
          .then(() => {
            this.is_loading = false;
          });
      }
    },
    createEntry() {
      if (!this.is_loading) {
        this.is_loading = true;
        axios
          .post(
            `/customer/${this.customer.id}/history_entry`,
            this.getParameters()
          )
          .then((response) => {
            this.$emit("submit");
            this.msgwindow.success("Historia creada con exito");
            this.$refs.modal.hide();
          })
          .catch((error) => {
            console.log("[ERR] createEntry", error);
          })
          .then(() => {
            this.is_loading = false;
          });
      }
    },
    getParameters() {
      return {
        clinic_id: this.clinic ? this.clinic.id : null,
        customer_id: this.customer.id,
        doctor_id: this.doctor_id,
        created_at: this.date,
        notes: this.notes,
        title: this.title,
        is_public: this.is_public,
        treatment_ids: this.selected_treatment_ids
          ? this.selected_treatment_ids
          : [],
        documents: this.document_ids,
        is_done: this.is_done,
        assign_doctor: this.assign_doctor,
      };
    },
    getCustomerTreatments(entry = null) {
      this.customer_treatments = [];
      axios
        .get(`/customer/${this.customer.id}/treatment`)
        .then((response) => {
          let ret = {};
          response.data.forEach((treatment) => {
            ret[treatment.id] = treatment;
          });
          this.customer_treatments = ret;
          if (this.is_editing && entry) {
            this.selected_treatment_ids = entry.treatments.map((t) => t.id);
          }
        })
        .catch((error) => {
          console.log("[ERR] getCustomerTreatments", error);
        });
    },
    removeTreatment(id) {
      if (this.readonly) return;

      this.selected_treatment_ids = this.selected_treatment_ids.filter(
        (treatment) => {
          return id != treatment;
        }
      );
    },
  },
};
</script>

<style lang="scss">
#customer-show-history-entry {
  .mb4px {
    margin-bottom: 4px !important;
  }

  .customer-info {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    background-color: var(--theme-grey-bg);
    border-bottom: 1px var(--theme-line-color) solid;
    padding: 15px;

    .customer-photo {
      width: 62px;
      height: 62px;
      background-size: cover;
      background-position: center center;
      border-radius: 31px;
      margin-left: 4px;
    }

    .customer-data {
      padding: 11px 18px;
      font-size: 20px;
      line-height: 1.25;
      color: var(--theme-text-color);
    }
  }

  #entry_select_notes .ql-container {
    height: 250px;
    overflow-y: scroll;
  }
}
</style>
